import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface OrderState {
  reportDeptList?: any
  reportDeptDetail?: any
}

const initialState: OrderState = {
  reportDeptList: {},
  reportDeptDetail: {},
  
}

export const reportDucks = createSlice({
  name: 'rate',
  initialState,
  reducers: {

    getListReportDeptList: (state: RootState, action: PayloadAction<any>) => {
      state.reportDeptList = { loading: true, queryStr: action.payload }
    },
    getListReportDeptListSuccess: (state, action: PayloadAction<any>) => {
      state.reportDeptList = { loading: false, ...action.payload }
    },
    getListReportDeptListFail: (state, action: PayloadAction<any>) => {
      state.reportDeptList = { loading: false, ...action.payload }
    },

    getListReportDeptDetail: (state: RootState, action: PayloadAction<any>) => {
      state.reportDeptDetail = { loading: true, queryStr: action.payload }
    },
    getListReportDeptDetailSuccess: (state, action: PayloadAction<any>) => {
      state.reportDeptDetail = { loading: false, ...action.payload }
    },
    getListReportDeptDetailFail: (state, action: PayloadAction<any>) => {
      state.reportDeptDetail = { loading: false, ...action.payload }
    },


  },
})

// Action creators are generated for each case reducer function
export const {

  getListReportDeptList,
  getListReportDeptListSuccess,
  getListReportDeptListFail,

  getListReportDeptDetail,
  getListReportDeptDetailSuccess,
  getListReportDeptDetailFail,

} = reportDucks.actions

export default reportDucks.reducer
